import FileModel, { FileStates } from "./FileModel";

const InvalidFileModel = FileModel.extend(
  /** @lends InvalidFileModel.prototype */
  {
    /**
     * Model representing a file of an unsupported type. Has most normal file's abilities overridden with no-op.
     * @param {File} file
     * @param {object} opts
     * @param {string} opts.unsupportedTypeMessage - message to be shown as error
     * @constructs
     * @extends FileModel
     */
    constructor(file, opts) {
      FileModel.call(this, file, opts);
      this.file = file;
      this.state = FileStates.INVALID;
    },

    getName() {
      return this.file.name;
    },

    getError() {
      return this.opts.unsupportedTypeMessage;
    },

    validate() {
      return false;
    },

    upload() {}
  });

export default InvalidFileModel;
